module.exports = __webpack_public_path__ + "img/bigbill.3a885434.png";